import { FlagAU, FlagUS } from "@/components/Flags";

export const STORAGE_KEY = "driveassure_country";
export const REGION_KEY = "driveassure_region";

// Australian states & territories. South Australia is the only live jurisdiction
// (Driver Training Reform 2027); the rest are coming soon.
const AU_REGIONS = [
  { code: "SA", name: "South Australia", authority: "Dept. for Infrastructure & Transport", status: "available", primary: true, note: "Driver Training Reform 2027" },
  { code: "NSW", name: "New South Wales", authority: "Transport for NSW", status: "soon" },
  { code: "VIC", name: "Victoria", authority: "Dept. of Transport & Planning", status: "soon" },
  { code: "QLD", name: "Queensland", authority: "Transport & Main Roads", status: "soon" },
  { code: "WA", name: "Western Australia", authority: "Dept. of Transport", status: "soon" },
  { code: "TAS", name: "Tasmania", authority: "Dept. of State Growth", status: "soon" },
  { code: "NT", name: "Northern Territory", authority: "Motor Vehicle Registry", status: "soon" },
  { code: "ACT", name: "Aust. Capital Territory", authority: "Access Canberra", status: "soon" },
];

// US states — all coming soon.
const US_STATES = [
  ["AL", "Alabama"], ["AK", "Alaska"], ["AZ", "Arizona"], ["AR", "Arkansas"], ["CA", "California"],
  ["CO", "Colorado"], ["CT", "Connecticut"], ["DE", "Delaware"], ["FL", "Florida"], ["GA", "Georgia"],
  ["HI", "Hawaii"], ["ID", "Idaho"], ["IL", "Illinois"], ["IN", "Indiana"], ["IA", "Iowa"],
  ["KS", "Kansas"], ["KY", "Kentucky"], ["LA", "Louisiana"], ["ME", "Maine"], ["MD", "Maryland"],
  ["MA", "Massachusetts"], ["MI", "Michigan"], ["MN", "Minnesota"], ["MS", "Mississippi"], ["MO", "Missouri"],
  ["MT", "Montana"], ["NE", "Nebraska"], ["NV", "Nevada"], ["NH", "New Hampshire"], ["NJ", "New Jersey"],
  ["NM", "New Mexico"], ["NY", "New York"], ["NC", "North Carolina"], ["ND", "North Dakota"], ["OH", "Ohio"],
  ["OK", "Oklahoma"], ["OR", "Oregon"], ["PA", "Pennsylvania"], ["RI", "Rhode Island"], ["SC", "South Carolina"],
  ["SD", "South Dakota"], ["TN", "Tennessee"], ["TX", "Texas"], ["UT", "Utah"], ["VT", "Vermont"],
  ["VA", "Virginia"], ["WA", "Washington"], ["WV", "West Virginia"], ["WI", "Wisconsin"], ["WY", "Wyoming"],
];
const US_REGIONS = US_STATES.map(([code, name]) => ({
  code, name, authority: "Dept. of Motor Vehicles", status: "soon",
}));

// Only Australia (with states) and the USA remain in the selector.
export const COUNTRIES = [
  {
    code: "AU", name: "Australia", Flag: FlagAU, status: "available", primary: true,
    regulator: "Regulated under each state & territory authority",
    subSelect: true, subLabel: "state or territory", subRegions: AU_REGIONS,
  },
  {
    code: "US", name: "United States", Flag: FlagUS, status: "available",
    regulator: "Regulated at state level (state DMVs)",
    subSelect: true, subLabel: "state", subRegions: US_REGIONS,
  },
];

export const findCountry = (code) => COUNTRIES.find((c) => c.code === code);
export const findRegion = (country, code) => country?.subRegions?.find((r) => r.code === code);
